export default __webpack_public_path__ + "static/CF_Cover_Cut-ae59b15b5d2b0381393c97da6490399f.png";